export const statuses = {
  Waiting: 'Waiting',
  Processing: 'Processing',
  CalcCompleted: 'CalcCompleted',
  JournalProcessing: 'JournalProcessing',
  Success: 'Success',
  Failed: 'Failed',
};

export const completedStatuses = [statuses.Success, statuses.Failed];
export const inProgressStatuses = [
  statuses.Waiting,
  statuses.Processing,
  statuses.CalcCompleted,
  statuses.JournalProcessing,
];
